import { WebShare } from './web-share.js';

WebShare.defineCustomElement();

export { WebShare };
